module.exports = __webpack_public_path__ + "img/ymc-logo-white.556f4c0d.png";